export const SHOWROOM_SECTION_SOURCE = 'showroomSection';
export const TRADE_IN_DEALER_APPRAISAL_SOURCE = 'USER';
export const TRADE_IN_RECORD_LABEL = 'Vehicle';
